import { UsersService } from './../../shared/services/users.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  MatLegacyAutocomplete as MatAutocomplete,
  MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent,
} from '@angular/material/legacy-autocomplete';
import { Router } from '@angular/router';
import { Address } from '@classes/address';
import { Client } from '@classes/client';
import { Dictionary } from '@classes/dictionary/dictionary';
import { DictionaryValue } from '@classes/dictionary/dictionaryValue';
import { RecurringOrder } from '@classes/recurring-order/recurring-order';
import { Site } from '@classes/site';
import { User } from '@classes/user/user';
import { ConfirmValidMatcher } from '@classes/validations/confirm-valid-matcher';
import { FormEditBaseComponent } from '@components/form-edit-base.component';
import { Day } from '@enums/days.enum';
import { RoleName } from '@enums/role-name.enum';
import { AddressesService } from '@services/addresses.service';
import { AuthService } from '@services/auth.service';
import { ClientsService } from '@services/clients.service';
import { DictionaryValuesService } from '@services/dictionaryValues.service';
import { RecurringOrdersService } from '@services/recurring-orders.service';
import { SitesService } from '@services/sites.service';
import { UiService } from '@services/ui.service';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-recurring-order-create',
  templateUrl: './recurring-order-create.component.html',
  styleUrls: ['./recurring-order-create.component.scss'],
})
export class RecurringOrderCreateComponent
  extends FormEditBaseComponent
  implements OnInit
{
  today = new Date();
  clients: Client[];
  sites: Site[];
  allTransportTypes: DictionaryValue[];
  urgencyLevels: DictionaryValue[];
  lots: DictionaryValue[];
  senders: Address[];
  receivers: Address[];

  order: RecurringOrder;

  stringMaxLength = 50;
  commentMaxLength = 500;
  isRestricted: boolean;
  isClient: boolean;
  isAdmin: boolean;
  isAdminWithOneClient: boolean;
  isLoadingLots: boolean;
  mustCheckDate: boolean;
  confirmValidMatcher = new ConfirmValidMatcher();

  invalidFields: string[] = [];
  invalidMessage: string = 'test';

  transportTypesSelected: DictionaryValue[] = [];
  devices: DictionaryValue[];
  filteredTransportTypes: Observable<DictionaryValue[]>;
  transportTypesCtrl = new UntypedFormControl();
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];

  clientForm = new UntypedFormGroup({
    client: new UntypedFormControl('', Validators.required),
  });

  canChooseValue = true;

  @ViewChild('deviceInput') deviceInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  recurrencies = [
    {
      name: 'Par jour',
      value: 'daily',
    },
    {
      name: 'Par mois',
      value: 'monthly',
    },
    {
      name: 'Par intervalle',
      value: 'interval',
    },
  ];

  daily = [
    {
      name: 'Tous les jours',
      value: 'everyday',
    },
    {
      name: 'Tous les jours de semaine',
      value: 'everyWeekDays',
    },
    {
      name: 'Tous les ...',
      value: 'custom',
    },
  ];

  monthly = [
    {
      name: 'Le',
      value: 'day',
    },
    {
      name: 'Le',
      value: 'the',
    },
  ];

  nthDays = [
    {
      name: 'premier',
      value: 'first',
    },
    {
      name: 'second',
      value: 'second',
    },
    {
      name: 'troisième',
      value: 'third',
    },
  ];

  days = [
    {
      value: 1,
      checked: false,
      disabled: false,
    },
    {
      value: 2,
      checked: false,
      disabled: false,
    },
    {
      value: 3,
      checked: false,
      disabled: false,
    },
    {
      value: 4,
      checked: false,
      disabled: false,
    },
    {
      value: 5,
      checked: false,
      disabled: false,
    },
    {
      value: 6,
      checked: false,
      disabled: false,
    },
    {
      value: 0,
      checked: false,
      disabled: false,
    },
  ];

  daysSelected = [];
  daysWeeklySelected = [];

  constructor(
    protected uiSrv: UiService,
    protected fb: UntypedFormBuilder,
    private authSrv: AuthService,
    private clientsSrv: ClientsService,
    private ordersSrv: RecurringOrdersService,
    private sitesSrv: SitesService,
    private dictionarySrv: DictionaryValuesService,
    private addressesSrv: AddressesService,
    private router: Router,
    private usersSrv: UsersService,
  ) {
    super(uiSrv, fb);
  }

  ngOnInit(): void {
    super.ngOnInit();

    // tslint:disable-next-line: max-line-length
    this.isRestricted =
      this.authSrv.getUser().role.name !== RoleName.super_admin &&
      this.authSrv.getUser().role.name !== RoleName.bizzdev;
    this.isClient =
      this.authSrv.getUser().role.name === RoleName.client ||
      this.authSrv.getUser().role.name === RoleName.admin_client;
    this.isAdmin =
      this.authSrv.getUser().role.name === RoleName.bizzdev ||
      this.authSrv.getUser().role.name === RoleName.super_admin ||
      this.authSrv.getUser().role.name === RoleName.admin;

    if (this.isAdmin) {
      let clients = [];
      clients = this.authSrv.getDecodedToken().client.split(',');
      if (clients.length > 1) {
        this.canChooseValue = false;
        this.isAdminWithOneClient = false;
      } else {
        this.canChooseValue = true;
        this.isAdminWithOneClient = true;
      }
    }

    this.initSubscriptions();
  }

  isControlSet(control: string): boolean {
    return !!this.editForm.get(control);
  }

  onFinish(): void {
    this.editFinished.emit();
    this.router.navigate(['/recurring-orders/list']);
  }

  onSubmit(): void {
    // this.isLoading = true;
    this.create();
  }

  private create(): void {
    const formValues = this.editForm.value;

    let cronExpression = null;
    if (formValues.recurrency !== 'interval') {
      cronExpression = this.createCronExpression();
    }

    const sitesPromise = new Promise((resolve, reject) => {
      if (typeof formValues.site === 'string') {
        let newSite = new Site(
          formValues.site,
          this.urgencyLevels[0].client,
          false,
        );

        this.sitesSrv.post(newSite).subscribe((newSiteFromSrv) => {
          formValues.site = newSiteFromSrv;
          resolve(true);
        });
      } else {
        resolve(true);
      }
    });

    Promise.all([sitesPromise]).then(() => {
      if (typeof formValues.sender.address === 'string') {
        formValues.sender.otherAddress = formValues.sender.address;
        formValues.sender.address = null;
      } else {
        formValues.sender.otherAddress = null;
      }

      formValues.receivers.map((receiver) => {
        if (typeof receiver.address === 'string') {
          receiver.otherAddress = receiver.address;
          receiver.address = null;
        } else {
          receiver.otherAddress = null;
        }

        if (receiver.type === 'isDelivery') {
          receiver.isDelivery = true;
          receiver.isPickup = false;
        } else {
          receiver.isDelivery = false;
          receiver.isPickup = true;
        }
      });

      let callDate = null;

      if (formValues.callDate) {
        let callTime = formValues.callDate.split(':');
        let dateNow = moment(new Date());
        callDate = dateNow
          .hours(callTime[0])
          .minutes(callTime[1])
          .utc()
          .toDate();
      }

      this.order = new RecurringOrder(
        formValues.site,
        formValues.urgencyLevel,
        formValues.ordererPhone,
        formValues.ordererName,
        formValues.sender,
        formValues.receivers,
        this.transportTypesSelected,
        cronExpression,
        this.minutesToAdd(),
        formValues.ordererComment,
        formValues.lot,
      );

      if (formValues.recurrency === 'interval') {
        this.order.intervalDays = formValues.intervalRecurrency;
        this.order.startDate = formValues.intervalStartDate;
        this.order.creationDate = formValues.intervalCreationDate;

        if (formValues.startTime) {
          let startTime = formValues.startTime.split(':');
          this.order.startDate = moment(formValues.intervalStartDate)
            .hours(startTime[0])
            .minutes(startTime[1])
            .utc()
            .subtract(2, 'hours')
            .toDate();
        }

        if (formValues.creationTime) {
          let creationTime = formValues.creationTime.split(':');
          this.order.creationDate = moment(formValues.intervalCreationDate)
            .hours(creationTime[0])
            .minutes(creationTime[1])
            .utc()
            .subtract(2, 'hours')
            .toDate();
        }
      }

      this.ordersSrv.post(this.order).subscribe(
        (orderCreated) => {
          this.isLoading = false;
          this.uiSrv.showSnackbar('recurringOrders.create.created', true);
          this.order = orderCreated;
          this.onFinish();
        },
        () => (this.order = null),
      );
    });
  }

  private initSubscriptions(): void {
    this.isLoading = true;

    if (this.canChooseValue) {
      const sitesPromise = new Promise((resolve, reject) => {
        this.sitesSrv.getList().subscribe((sitesFromSrv) => {
          this.sites = sitesFromSrv;
          resolve(true);
        });
      });

      const clientsPromise = new Promise((resolve, reject) => {
        this.clientsSrv.getList().subscribe((clientsFromSrv) => {
          this.clients = clientsFromSrv;
          resolve(true);
        });
      });

      const typeTransportsPromise = new Promise((resolve, reject) => {
        this.dictionarySrv.getTransportList().subscribe((transportsFromSrv) => {
          this.allTransportTypes = transportsFromSrv;
          // this.filteredTransportTypes = transportsFromSrv;
          this.filteredTransportTypes =
            this.transportTypesCtrl.valueChanges.pipe(
              startWith(null),
              map((fruit: string | null) =>
                fruit ? this._filter(fruit) : this.allTransportTypes.slice(),
              ),
            );
          resolve(true);
        });
      });

      const urgencyLevelsPromise = new Promise((resolve, reject) => {
        this.dictionarySrv
          .getUrgencyList()
          .subscribe((urgencyLevelsFromSrv) => {
            this.urgencyLevels = urgencyLevelsFromSrv;
            resolve(true);
          });
      });

      const addressPromise = new Promise((resolve, reject) => {
        this.addressesSrv.getList().subscribe((addressessFromSrv) => {
          this.senders = addressessFromSrv.filter(
            (address) => address.isSender,
          );
          this.receivers = addressessFromSrv.filter(
            (address) => address.isReceiver,
          );
          resolve(true);
        });
      });

      Promise.all([
        sitesPromise,
        clientsPromise,
        typeTransportsPromise,
        urgencyLevelsPromise,
        addressPromise,
      ]).then(() => {
        this.isLoading = false;
        this.initForm();
      });
    } else {
      const clientsPromise = new Promise((resolve, reject) => {
        this.clientsSrv.getList().subscribe((clientsFromSrv) => {
          this.clients = clientsFromSrv;
          resolve(true);
        });
      });

      const addressPromise = new Promise((resolve, reject) => {
        this.addressesSrv.getList().subscribe((addressessFromSrv) => {
          this.senders = addressessFromSrv.filter(
            (address) => address.isSender,
          );
          this.receivers = addressessFromSrv.filter(
            (address) => address.isReceiver,
          );
          resolve(true);
        });
      });

      Promise.all([clientsPromise, addressPromise]).then(() => {
        this.isLoading = false;
      });
    }
  }

  private initForm(): void {
    const startMoment: moment.Moment = moment(new Date());
    const startTime: string = startMoment.add(1, 'hours').format('HH:mm');

    this.editForm = this.fb.group({
      ordererComment: [null, [Validators.maxLength(this.commentMaxLength)]],
      urgencyLevel: new UntypedFormControl(null, [Validators.required]),
      lot: new UntypedFormControl(null),
      // cronDescription: new FormControl(null),
      // cronExpression: new FormControl(null, Validators.required),
      // minutesToAdd: new FormControl(null, Validators.required),
      creationTime: new UntypedFormControl(null, Validators.required),
      startTime: new UntypedFormControl(null, Validators.required),
      recurrency: new UntypedFormControl(null),
      dailyRecurrency: new UntypedFormControl(null),
      weeklyRecurrency: new UntypedFormControl(null),
      dayMonthlyRecurrency: new UntypedFormControl(null),
      intervalRecurrency: new UntypedFormControl(null),
      intervalStartDate: new UntypedFormControl(null),
      intervalCreationDate: new UntypedFormControl(null),
      // monthlyRecurrency: new FormControl(null),
      // nthDayMonthlyRecurrency: new FormControl(null),
      // dayChoosedMonthlyRecurrency: new FormControl(null),
      // nthMonthMonthlyRecurrency: new FormControl(null),
      sender: this.fb.group(
        {
          address: [null, [Validators.required]],
          otherAddress: [null],
          service: [
            null,
            [Validators.required, Validators.maxLength(this.stringMaxLength)],
          ],
          ordererComment: [null, [Validators.maxLength(this.commentMaxLength)]],
          isPickup: [true],
          isDelivery: [false],
        },
        Validators.required,
      ),
      receivers: this.fb.array([], Validators.required),
      ordererPhone: new UntypedFormControl(null, [
        Validators.maxLength(this.stringMaxLength),
      ]),
      ordererName: new UntypedFormControl(null, [
        Validators.maxLength(this.stringMaxLength),
      ]),
      site: new UntypedFormControl(null, [Validators.required]),
    });

    this.onAddReceiver();

    // reset les jours sélectionnés
    this.editForm.get('recurrency').valueChanges.subscribe(() => {
      this.daysSelected = [];
    });

    this.editForm.valueChanges.subscribe(() => {
      this.invalidFields = [];
      this.invalidFields = this.findInvalidControls();
      this.invalidMessage = 'Le formulaire est incomplet';
      this.invalidFields.map((field) => {
        this.invalidMessage = this.invalidMessage + ' ' + field;
      });
    });

    this.editForm.get('site').valueChanges.subscribe((site) => {
      this.isLoadingLots = true;
      this.lots = [];
      this.editForm.get('lot').reset();
      if (typeof site !== 'string') {
        this.dictionarySrv.getLotsList(site.id).subscribe((lotsFromSrv) => {
          this.lots = lotsFromSrv;
          this.isLoadingLots = false;

          this.editForm.get('lot').setValidators([Validators.required]);

          if (this.lots.length === 0) {
            this.editForm.get('lot').removeValidators(Validators.required);
          } else if (this.lots.length === 1) {
            this.editForm.get('lot').setValue(this.lots[0]);
          }
          this.editForm.get('lot').updateValueAndValidity();
        });
      }
    });
  }

  public findInvalidControls() {
    const invalid = [];

    if (this.editForm.controls) {
      const controls = this.editForm.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          invalid.push(this.translateFields(name));
        }
      }
    }

    //check si le dernier receiver est bien une livraison
    let lastReceiver =
      this.editForm.value.receivers[this.editForm.value.receivers.length - 1];

    if (lastReceiver.type === 'isPickup') {
      invalid.push(' | La dernière étape est un enlèvement');
    }

    if (this.transportTypesSelected.length === 0) {
      invalid.push(" | Il n'y a aucun type de transport");
    }
    return invalid;
  }

  translateFields(name): string {
    if (name === 'site') {
      return " | Donneur d'ordre";
    }
    if (name === 'urgencyLevel') {
      return " | Niveau d'urgence";
    }
    if (name === 'sender') {
      return " | Lieu d'enlèvement incomplet";
    }
    if (name === 'receivers') {
      return ' | Destinataire(s) incomplet(s)';
    }
    if (name === 'transportType') {
      return ' | Aucun type de transport';
    }
    if (name === 'lot') {
      return ' | Lot incomplet';
    }
  }

  minTransportType(min = 1): any {
    return (formArray: UntypedFormArray) => {
      return formArray.controls.length >= min ? null : { required: true };
    };
  }

  onAddTransportType(transportType?: Dictionary): void {
    this.transportTypesFields.push(
      this.fb.control(null, [Validators.required]),
    );
  }

  removeTransportType(transportTypeToRemove): void {
    this.getArray('transportTypes').controls.splice(
      this.getArray('transportTypes').controls.indexOf(transportTypeToRemove),
      1,
    );
    this.editForm.value.transportTypes.splice(
      this.editForm.value.transportTypes.indexOf(transportTypeToRemove.value),
      1,
    );
  }

  get transportTypesFields(): UntypedFormArray {
    return this.editForm.get('transportTypes') as UntypedFormArray;
  }

  onAddReceiver(): void {
    const newGroup = this.fb.group({
      address: [null, [Validators.required]],
      otherAddress: [null],
      service: [
        null,
        [Validators.required, Validators.maxLength(this.stringMaxLength)],
      ],
      ordererComment: [null, [Validators.maxLength(this.commentMaxLength)]],
      type: ['isDelivery', [Validators.required]],
    });

    this.getArray('receivers').push(newGroup);
  }

  onRemoveReceiver(index: number): void {
    this.getArray('receivers').removeAt(index);
  }

  onCheckboxChange(e): any {
    const checkArray: UntypedFormArray = this.editForm.get(
      'transportTypes',
    ) as UntypedFormArray;

    if (e.checked) {
      checkArray.push(new UntypedFormControl(e.source.value));
    } else {
      let i: number = 0;
      checkArray.controls.forEach((item: UntypedFormControl) => {
        if (item.value === e.source.value) {
          checkArray.removeAt(i);
          return;
        }
        i++;
      });
    }
  }

  remove(fruit: DictionaryValue): void {
    const index = this.transportTypesSelected.indexOf(fruit);

    if (index >= 0) {
      this.transportTypesSelected.splice(index, 1);
    }

    this.checkIfSelected();
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    document.getElementById('deviceChipList').blur();
    if (!this.transportTypesSelected.includes(event.option.value)) {
      this.transportTypesSelected.push(event.option.value);
      // this.devices = this._filter(event.option.value);
      this.checkIfSelected();

      this.deviceInput.nativeElement.value = '';
    }
  }

  checkIfSelected() {
    this.filteredTransportTypes = this.filteredTransportTypes.pipe(
      map((array) => {
        return array.map((element) => {
          if (this.transportTypesSelected.includes(element)) {
            element.selected = true;
          } else {
            element.selected = false;
          }
          return element;
        });
      }),
    );
  }

  private _filter(value?): DictionaryValue[] {
    let filterValue = '';

    if (value.name) {
      filterValue = value.name.toLowerCase();
      return this.allTransportTypes.filter((el) => {
        return el.id === value.id;
      });
    } else {
      filterValue = value.toLowerCase();
      return this.allTransportTypes.filter(
        (transportType) =>
          transportType.name.toLowerCase().indexOf(filterValue) === 0,
      );
    }
  }

  clearDevicesSelected(): void {
    this.transportTypesSelected = [];
    this.filteredTransportTypes.pipe(
      map((fruit) => {
        return this.allTransportTypes;
      }),
    );
    this.checkIfSelected();
  }

  getClientControl(control: string): UntypedFormControl {
    return this.clientForm.get(control) as UntypedFormControl;
  }

  chooseClient() {
    this.isLoading = true;
    let clientId = this.clientForm.value.client.id;
    let clientArray = [clientId];
    this.sites = [];
    this.lots = [];

    if (this.editForm) {
      this.editForm.get('urgencyLevel').setValue(null);
      this.editForm.get('lot').setValue(null);
    }
    if (this.transportTypesSelected.length > 0) {
      this.transportTypesSelected = [];
    }

    const sitesPromise = new Promise((resolve, reject) => {
      this.sitesSrv.getListByClients(clientArray).subscribe((sitesFromSrv) => {
        this.sites = sitesFromSrv;
        resolve(true);
      });
    });

    const typeTransportsPromise = new Promise((resolve, reject) => {
      this.dictionarySrv
        .getTransportListById2(clientId)
        .subscribe((transportsFromSrv) => {
          this.allTransportTypes = transportsFromSrv;
          this.filteredTransportTypes =
            this.transportTypesCtrl.valueChanges.pipe(
              startWith(null),
              map((fruit: string | null) =>
                fruit ? this._filter(fruit) : this.allTransportTypes.slice(),
              ),
            );

          // this.transportTypesCtrl.valueChanges.subscribe(() => {
          //   this.invalidFields = this.findInvalidControls();
          //   this.invalidFields.map(field => {
          //     this.invalidMessage = this.invalidMessage + ' ' + field;
          //   })
          // })

          resolve(true);
        });
    });

    const urgencyLevelsPromise = new Promise((resolve, reject) => {
      this.dictionarySrv
        .getUrgencyListById2(clientId)
        .subscribe((urgencyLevelsFromSrv) => {
          this.urgencyLevels = urgencyLevelsFromSrv;
          resolve(true);
        });
    });

    Promise.all([
      sitesPromise,
      typeTransportsPromise,
      urgencyLevelsPromise,
    ]).then(() => {
      this.isLoading = false;
      this.canChooseValue = true;
      this.initForm();
    });
  }

  selectDay(event, day) {
    if (event.source.checked === true) {
      day.checked = true;
      this.daysSelected.push(day.value);
    } else {
      day.checked = false;
      this.daysSelected.map((oneDay, index) => {
        if (oneDay === day.value) {
          this.daysSelected.splice(index, 1);
        }
      });
    }
  }

  selectWeeklyDay(event, day) {
    if (event.source.checked === true) {
      day.checked = true;
      this.daysWeeklySelected.push(day.value);
    } else {
      day.checked = false;
      this.daysWeeklySelected.map((oneDay, index) => {
        if (oneDay === day.value) {
          this.daysWeeklySelected.splice(index, 1);
        }
      });
    }
  }

  showDayText(day: Day): string {
    return 'billing.schedules.days.' + Day[day];
  }

  createCronExpression(): string {
    let cronExpression = '';
    let formValues = this.editForm.value;
    let minutes = formValues.creationTime.split(':')[1];
    let hours = formValues.creationTime.split(':')[0];
    cronExpression += minutes + ' ' + hours;

    if (formValues.recurrency === 'daily') {
      if (formValues.dailyRecurrency === 'everyday') {
        cronExpression += ' * * *';
      } else if (formValues.dailyRecurrency === 'everyWeekDays') {
        cronExpression += ' * * 1-5';
      } else if (formValues.dailyRecurrency === 'custom') {
        let days = '';
        this.daysSelected.map((day, index) => {
          if (index === 0) {
            days += day;
          } else {
            days += ',' + day;
          }
        });
        cronExpression += ' * * ' + days;
      }
    } else if (formValues.recurrency === 'weekly') {
      let frequency = '*/' + formValues.weeklyRecurrency;
      let days = '';
      this.daysSelected.map((day, index) => {
        if (index === 0) {
          days += day;
        } else {
          days += ',' + day;
        }
      });

      cronExpression += ' 0 * ' + days;
    } else if (formValues.recurrency === 'monthly') {
      // if (formValues.monthlyRecurrency === 'day') {
      let day = formValues.dayMonthlyRecurrency;
      // let month = formValues.nthMonthMonthlyRecurrency;

      cronExpression += ' ' + day + ' *' + ' *';
      // } else if (formValues.monthlyRecurrency ===  'the') {

      // }
    }

    return cronExpression;
  }

  minutesToAdd(): number {
    let formValues = this.editForm.value;

    let minutesCreationTime = parseInt(formValues.creationTime.split(':')[1]);
    let hoursCreationTime = parseInt(formValues.creationTime.split(':')[0]);
    let totalMinutesCreationTime = hoursCreationTime * 60 + minutesCreationTime;

    let minutesStartTime = parseInt(formValues.startTime.split(':')[1]);
    let hoursStartTime = parseInt(formValues.startTime.split(':')[0]);
    let totalMinutesStartTime = hoursStartTime * 60 + minutesStartTime;

    let minutesToAdd = totalMinutesStartTime - totalMinutesCreationTime;

    return minutesToAdd;
  }
}
